


































import Vue from 'vue'
import BaseIcon from 'vuecomponents/base_icon.vue'
import { Component, Watch } from 'vue-property-decorator'
import { namespace, Getter, State } from 'vuex-class'
const mapModule = namespace('map')
import appCan from 'bits/app_can'

@Component({
  components: {
    BaseIcon,
    SurfaceMapLocationPickerPanel: () => import('vuecomponents/surface_map_location_picker_panel.vue'),
  },
})
class SurfaceAddPostMap extends Vue {
  @State headerHeight
  @State isApp
  @Getter isUsingNewSurfaceShadows
  @mapModule.Getter map
  @mapModule.Getter isPickingLocation
  @mapModule.Getter postWithLocationBeingEditedCid
  @mapModule.Getter isPreviewPanelShown
  @mapModule.Action startPickingLocation
  @mapModule.Action stopPickingLocation
  @mapModule.Action hidePickLocationPanel
  @mapModule.Action pickLocation
  @mapModule.Action enableMapFittingMarkersBounds

  animationStyle!: HTMLStyleElement
  classes: string[] = []

  pick(latLng, name) {
    this.pickLocation({ latLng, name })
    // If user add a new post, we fit all the markers.
    // this.enableMapFittingMarkersBounds()
  }

  get isAppOpeningNativeLocationPicker() {
    return this.isApp && appCan('useNativeMapLocationPicker')
  }

  @Watch('headerHeight')
  // Update stylesheet accordingly to the height of the header
  respondToHeaderHeightUpdate() {
    this.$nextTick(() => {
      this.animationStyle.innerHTML = `
      .map-input.fab-morphing-leave-to{
        margin-top: ${this.headerHeight - 28}px !important;
      }
      `
    })
  }

  @Watch('isPickingLocation')
  respondToFabTransforming(isPickingLocation) {
    if (isPickingLocation) {
      this.classes = []
    }
  }

  respondToPinDragged() {
    this.classes = ['panel-hidden']
  }

  respondToPinDropped(location) {
    if (!location) {
      this.classes = []
    } else {
      this.classes = ['panel-hidden', 'fab-appear']
    }
  }

  mounted() {
    // Add stylesheet for the panel's animation
    this.$nextTick(() => {
      this.animationStyle = document.createElement('style') as HTMLStyleElement
      this.animationStyle.innerHTML = `
      .map-input.fab-morphing-leave-to{
        margin-top: ${this.headerHeight - 28}px !important;
      }
      `
      document.head.appendChild(this.animationStyle)
    })
  }
}
export default SurfaceAddPostMap
